import { ICommonbannerConfig } from '../interface/ICommonbanner';
import NcBanner from './ncBanner/NcBanner';

/**
 * @alias Commonbanner
 * @category Commonbanner
 * @param _config {ICommonbannerConfig} 
 * @example
 * var ncBannerData = {.....}
 * if (window.ncui) {
 *    new window.ncui.commonBanner({
 *        wstatic:"https:\/\/sb-assets.plaync.com",
 *        isLogin: false,
 *        ncBanner: ncBannerData
 *    });
 * }
 */
export default class Index {
    constructor(_config: ICommonbannerConfig) {        
        // console.log('-------commobanner START-------', _config);
        new NcBanner(_config);
	}    
}
// end of class